class CatalogueService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getPage(params) {
    return this.apiService.get('/api/v1/catalogues', params);
  }

  uploadCatalogue(formData) {
    return this.apiService.upload('/api/v1/catalogues/upload', formData);
  }

  downloadCatalogue(filename) {
    return this.apiService.download(`/api/v1/catalogues/download/${filename}`, filename);
  }

  deleteCatalogues(params) {
    return this.apiService.delete('/api/v1/catalogues', params);
  }

  updateCatalogue(id, params) {
    return this.apiService.put(`/api/v1/catalogues/${id}`, params);
  }
}

export default CatalogueService;
